(function () {
  var core = window.DPPThemeProduct || {}
  var bundleCore = window.DPPThemeProductBundles || {}
  var formatMoney = core.formatMoney, normalizeToCents = core.normalizeToCents, escapeHtml = core.escapeHtml
  var getThemeTranslations = core.getThemeTranslations, getCartUrl = core.getCartUrl, getShopifyFeatures = core.getShopifyFeatures
  var replaceTokens = core.replaceTokens, syncButtonState = core.syncButtonState
  var setBodyScrollLock = core.setBodyScrollLock, trapFocusWithin = core.trapFocusWithin
  var buildVariantDisplayTitle = bundleCore.buildVariantDisplayTitle, buildBundleDisplayTitle = bundleCore.buildBundleDisplayTitle, fetchBundleVariantDetails = bundleCore.fetchBundleVariantDetails
  var getBundleStepValue = bundleCore.getBundleStepValue, setupProductListBundleConfigurator = bundleCore.setupProductListBundleConfigurator
  function setupBundleConfigurator() {
    var roots = Array.prototype.slice.call(document.querySelectorAll('[data-bundle-configurator-root]'))
    if (roots.length === 0) return
    roots.forEach(function (root) {
      var payloadScript = root.querySelector('[data-bundle-configurator-data]')
      if (!payloadScript) return
      if (root.hasAttribute('data-bundle-configurator-ready')) return
      root.setAttribute('data-bundle-configurator-ready', 'true')
      var payload
      try {
        payload = JSON.parse(payloadScript.textContent || '{}')
      } catch (_error) {
        return
      }
      var payloadSteps = Array.isArray(payload.steps)
        ? payload.steps.filter(function (step) {
            return step && Array.isArray(step.products) && step.products.length > 0
          })
        : []
      var section = root.closest('[data-product-section]')
      if (!section) return
      if (payloadSteps.length > 0) {
        setupProductListBundleConfigurator(root, section, payload, payloadSteps)
        return
      }
      var entries = Array.isArray(payload.entries)
        ? payload.entries.filter(function (entry) {
            return entry && getBundleStepValue(entry, 'primary')
          })
        : []
      if (entries.length === 0) {
        root.classList.add('hidden')
        var buyBoxLink = section.querySelector('[data-bundle-buybox-link]')
        if (buyBoxLink) buyBoxLink.classList.add('hidden')
        return
      }
      var sourceSelect = section.querySelector('[data-variant-select]')
      var sourceCurrent = root.querySelector('[data-bundle-source-current]')
      var sourceButtons = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-source-option]'))
      function getConfiguredStepLabel(type, number) {
        var optionsRoot = root.querySelector('[data-bundle-configurator-' + type + '-options]')
        var configuredLabel = optionsRoot ? optionsRoot.getAttribute('data-bundle-step-select-label') : ''
        if (configuredLabel) return configuredLabel

        var stepLabelTemplate = root.getAttribute('data-bundle-step-label') || 'Step __NUMBER__'
        return replaceTokens(stepLabelTemplate, { NUMBER: String(number) })
      }
      var stepConfigs = [
        {
          type: 'primary',
          label: getConfiguredStepLabel('primary', 2),
          role: 'step_1',
          valueKey: 'primaryValue',
          variantIdKey: 'primaryVariantId',
          variantIdsKey: 'primaryVariantIds',
          quantityKey: 'primaryQuantity',
          quantitiesKey: 'primaryVariantQuantities',
          optionsRoot: root.querySelector('[data-bundle-configurator-primary-options]'),
          stepRoot: root.querySelector('[data-bundle-configurator-primary-step]')
        },
        {
          type: 'secondary',
          label: getConfiguredStepLabel('secondary', 3),
          role: 'step_2',
          valueKey: 'secondaryValue',
          variantIdKey: 'secondaryVariantId',
          variantIdsKey: 'secondaryVariantIds',
          quantityKey: 'secondaryQuantity',
          quantitiesKey: 'secondaryVariantQuantities',
          optionsRoot: root.querySelector('[data-bundle-configurator-secondary-options]'),
          stepRoot: root.querySelector('[data-bundle-configurator-secondary-step]')
        },
        {
          type: 'tertiary',
          label: getConfiguredStepLabel('tertiary', 4),
          role: 'step_3',
          valueKey: 'tertiaryValue',
          variantIdKey: 'tertiaryVariantId',
          variantIdsKey: 'tertiaryVariantIds',
          quantityKey: 'tertiaryQuantity',
          quantitiesKey: 'tertiaryVariantQuantities',
          optionsRoot: root.querySelector('[data-bundle-configurator-tertiary-options]'),
          stepRoot: root.querySelector('[data-bundle-configurator-tertiary-step]')
        },
        {
          type: 'quaternary',
          label: getConfiguredStepLabel('quaternary', 5),
          role: 'step_4',
          valueKey: 'quaternaryValue',
          variantIdKey: 'quaternaryVariantId',
          variantIdsKey: 'quaternaryVariantIds',
          quantityKey: 'quaternaryQuantity',
          quantitiesKey: 'quaternaryVariantQuantities',
          optionsRoot: root.querySelector('[data-bundle-configurator-quaternary-options]'),
          stepRoot: root.querySelector('[data-bundle-configurator-quaternary-step]')
        }
      ]
      var summaryLink = root.querySelector('[data-bundle-summary-link]')
      var summaryTitle = root.querySelector('[data-bundle-summary-title]')
      var summaryHelper = root.querySelector('[data-bundle-summary-helper]')
      var componentsRoot = root.querySelector('[data-bundle-configurator-components]')
      var priceRoot = root.querySelector('[data-bundle-configurator-price]')
      var feedback = root.querySelector('[data-bundle-configurator-feedback]')
      var priceEl = section.querySelector('[data-variant-price]')
      var compareEl = section.querySelector('[data-variant-compare]')
      var compareWrapEl = section.querySelector('[data-variant-compare-wrap]')
      var discountBadgeEl = section.querySelector('[data-variant-discount-badge]')
      var availableStateEls = section.querySelectorAll('[data-variant-available-state]')
      var unavailableStateEls = section.querySelectorAll('[data-variant-unavailable-state]')
      var titleBadgeEl = section.querySelector('[data-variant-title-badge]')
      var submitButtons = section.querySelectorAll('[data-add-to-cart], [data-direct-checkout]')
      var productTranslations = getThemeTranslations().product || {}
      var summaryBaseHref = summaryLink ? summaryLink.href : '#'
      var emptyLabel = root.getAttribute('data-bundle-empty-label') || ''
      var noMatchLabel = root.getAttribute('data-bundle-no-match-label') || ''
      var mappingNote = root.getAttribute('data-bundle-mapping-note') || ''
      var fixedLabel = root.getAttribute('data-bundle-fixed-label') || ''
      var discountLabel = root.getAttribute('data-bundle-discount-label') || ''
      var discountRowLabel = root.getAttribute('data-bundle-discount-row-label') || discountLabel
      var volumeSavingsLabel = root.getAttribute('data-bundle-volume-savings-label') || ''
      var subtotalLabel = root.getAttribute('data-bundle-subtotal-label') || ''
      var totalSavingsLabel = root.getAttribute('data-bundle-total-savings-label') || ''
      var totalLabel = root.getAttribute('data-bundle-total-label') || ''
      var priceLabel = root.getAttribute('data-bundle-price-label') || ''
      var compareLabel = root.getAttribute('data-bundle-compare-label') || ''
      var savingsLabel = root.getAttribute('data-bundle-savings-label') || ''
      var summaryItemsLabel = root.getAttribute('data-bundle-summary-items-label') || ''
      var sourceItemLabel = root.getAttribute('data-bundle-source-item-label') || ''
      var discountRate = parseFloat(root.getAttribute('data-bundle-discount-rate') || '0')
      var configuratorId = payload.configuratorId || ''
      var baseProductId = payload.baseProductId || ''
      var quantityTemplate = root.getAttribute('data-bundle-component-quantity') || '__QUANTITY__x'
      var bundleDetailsByGid = {}
      var pendingSourceLineKey = ''
      var selectionState = stepConfigs.reduce(function (state, step) {
        state[step.type] = ''
        return state
      }, {})
      var currentEntry = null
      var popup = root.querySelector('[data-bundle-popup]')
      var popupSource = popup ? popup.querySelector('[data-bundle-popup-source]') : null
      var popupItems = popup ? popup.querySelector('[data-bundle-popup-items]') : null
      var popupPrice = popup ? popup.querySelector('[data-bundle-popup-price]') : null
      var popupSavingsBadge = popup ? popup.querySelector('[data-bundle-popup-savings-badge]') : null
      var popupCopy = popup ? popup.querySelector('[data-bundle-popup-copy]') : null
      var popupFeedback = popup ? popup.querySelector('[data-bundle-popup-feedback]') : null
      var popupSubmit = popup ? popup.querySelector('[data-bundle-popup-submit]') : null
      var popupConfigure = popup ? popup.querySelector('[data-bundle-popup-configure]') : null
      var popupCurrentLabel = root.getAttribute('data-bundle-popup-current-label') || ''
      var popupBundlePriceLabel = root.getAttribute('data-bundle-popup-bundle-price-label') || ''
      var popupPreviouslyFocused = null
      function formatSavingsBadgeLabel(amountCents) {
        var amount = formatMoney(amountCents, window.Shopify && window.Shopify.money_format)
        return savingsLabel ? replaceTokens(savingsLabel, { AMOUNT: amount }) : amount
      }

      function syncPopupSavingsBadge(amountCents) {
        if (!popupSavingsBadge) return
        if (amountCents > 0) {
          popupSavingsBadge.textContent = formatSavingsBadgeLabel(amountCents)
          popupSavingsBadge.classList.remove('hidden')
          popupSavingsBadge.classList.add('inline-flex')
        } else {
          popupSavingsBadge.textContent = ''
          popupSavingsBadge.classList.add('hidden')
          popupSavingsBadge.classList.remove('inline-flex')
        }
      }

      function getSourceOption() {
        return sourceSelect && sourceSelect.selectedIndex >= 0 ? sourceSelect.options[sourceSelect.selectedIndex] : null
      }
      function getSourceVariantId() {
        if (sourceSelect) return String(sourceSelect.value || '')
        return String(root.getAttribute('data-current-variant-id') || '')
      }
      function syncTitleBadgeFromSource() {
        var sourceOption = getSourceOption()
        var title = sourceOption ? (sourceOption.getAttribute('data-title') || sourceOption.textContent || '') : ''
        if (titleBadgeEl && title) {
          var variantPrefix = productTranslations.variantPrefix || ''
          titleBadgeEl.textContent = replaceTokens(variantPrefix, { TITLE: title })
        }
        if (sourceCurrent) {
          sourceCurrent.textContent = title || fixedLabel || ''
        }
        sourceButtons.forEach(function (button) {
          var isActive = String(button.getAttribute('data-source-variant-id') || '') === getSourceVariantId()
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false')
          button.classList.toggle('border-dpp-teal', isActive)
          button.classList.toggle('bg-dpp-tealSoft', isActive)
          button.classList.toggle('text-dpp-focus', isActive)
        })
      }
      function setPriceDisplay(priceCents, compareAtCents) {
        var normalizedPriceCents = normalizeToCents(priceCents)
        var normalizedCompareAtCents = normalizeToCents(compareAtCents)

        if (priceEl) priceEl.textContent = formatMoney(normalizedPriceCents, window.Shopify && window.Shopify.money_format)
        if (compareEl) {
          if (normalizedCompareAtCents > normalizedPriceCents) {
            compareEl.textContent = formatMoney(normalizedCompareAtCents, window.Shopify && window.Shopify.money_format)
            if (compareWrapEl) compareWrapEl.classList.remove('hidden')
          } else if (compareWrapEl) {
            compareWrapEl.classList.add('hidden')
          }
        }

        if (discountBadgeEl) {
          var discountPercentage = normalizedCompareAtCents > normalizedPriceCents && normalizedCompareAtCents > 0
            ? Math.round(((normalizedCompareAtCents - normalizedPriceCents) * 100) / normalizedCompareAtCents)
            : 0
          var discountLabel = discountBadgeEl.getAttribute('data-discount-label') || 'Discount'

          discountBadgeEl.classList.toggle('hidden', discountPercentage <= 0)
          discountBadgeEl.textContent = discountPercentage > 0 ? '-' + discountPercentage + '%' : ''
          discountBadgeEl.setAttribute('aria-label', discountPercentage > 0 ? discountLabel + ' ' + discountPercentage + '%' : discountLabel)
        }
      }
      function setAvailabilityState(available) {
        Array.prototype.forEach.call(availableStateEls, function (element) {
          element.classList.toggle('hidden', !available)
        })
        Array.prototype.forEach.call(unavailableStateEls, function (element) {
          element.classList.toggle('hidden', available)
        })
        submitButtons.forEach(function (button) {
          syncButtonState(button, available)
        })
      }
      function setFeedback(message) {
        if (!feedback) return
        if (message) {
          feedback.textContent = message
          feedback.classList.remove('hidden')
        } else {
          feedback.textContent = ''
          feedback.classList.add('hidden')
        }
      }
      function renderSummary(bundleVariant, helperText) {
        var sourceOption = getSourceOption()
        var sourceTitle = sourceOption ? (sourceOption.getAttribute('data-title') || sourceOption.textContent || '').trim() : ''
        var baseTitle = summaryTitle ? (summaryTitle.getAttribute('data-base-title') || '') : ''
        var sourceItemTitle = sourceTitle ? (baseTitle + ' - ' + sourceTitle) : baseTitle
        if (summaryLink) {
          summaryLink.href = summaryBaseHref
        }
        if (summaryTitle) {
          if (!baseTitle) {
            baseTitle = (summaryTitle.textContent || '').split(' - ')[0].trim()
            summaryTitle.setAttribute('data-base-title', baseTitle)
          }
          sourceItemTitle = sourceTitle ? (baseTitle + ' - ' + sourceTitle) : baseTitle
          summaryTitle.textContent = sourceItemTitle
        }
        if (summaryHelper) summaryHelper.textContent = ''
        if (componentsRoot) {
          var bundleComponents = bundleVariant && Array.isArray(bundleVariant.bundleComponents) ? bundleVariant.bundleComponents : []
          var summaryItems = bundleComponents.length > 0
            ? bundleComponents.map(function (component) {
                return {
                  quantity: component.quantity || 1,
                  title: buildVariantDisplayTitle(component.productTitle, component.variantTitle, component.variantGid, component.firstVariantGid),
                  label: ''
                }
              })
            : []
          componentsRoot.innerHTML = summaryItems.length > 0
            ? '<p class="text-[11px] font-extrabold uppercase tracking-[0.18em] text-dpp-muted">' + escapeHtml(summaryItemsLabel) + '</p>' +
              '<div class="grid gap-2">' +
              '<div class="flex items-start gap-3 text-sm leading-snug">' +
              '<span class="inline-flex min-h-7 min-w-9 items-center justify-center rounded-full bg-dpp-tealSoft px-2 text-xs font-extrabold text-dpp-focus">' + escapeHtml(replaceTokens(quantityTemplate, { QUANTITY: '1' })) + '</span>' +
              '<span class="min-w-0 pt-1 font-semibold text-dpp-text">' + escapeHtml(sourceItemTitle || '') + '</span>' +
              '</div>' +
              summaryItems.map(function (item) {
                var quantityLabel = replaceTokens(quantityTemplate, { QUANTITY: String(item.quantity || 1) })
                return '' +
                  '<div class="flex items-start gap-3 text-sm leading-snug">' +
                  '<span class="inline-flex min-h-7 min-w-9 items-center justify-center rounded-full bg-dpp-tealSoft px-2 text-xs font-extrabold text-dpp-focus">' + escapeHtml(quantityLabel) + '</span>' +
                  '<span class="min-w-0 pt-1 font-semibold text-dpp-text">' + escapeHtml(item.title || '') + '</span>' +
                  '</div>'
              }).join('') + '</div>'
            : ''
        }
        if (priceRoot) {
          var priceCents = bundleVariant ? normalizeToCents(bundleVariant.bundlePriceCents) : 0
          var compareAtCents = bundleVariant ? normalizeToCents(bundleVariant.bundleCompareAtPriceCents) : 0
          if (priceCents > 0 && compareAtCents <= priceCents && discountRate > 0 && discountRate < 100) {
            compareAtCents = Math.round(priceCents / (1 - (discountRate / 100)))
          }
          var savingsCents = compareAtCents > priceCents ? compareAtCents - priceCents : 0
          var inferredBundleDiscount = discountRate > 0 && discountRate < 100 ? Math.round(compareAtCents * (discountRate / 100)) : savingsCents
          var bundleDiscount = Math.min(savingsCents, inferredBundleDiscount)
          var volumeSavings = Math.max(savingsCents - bundleDiscount, 0)
          if (priceCents > 0) {
            priceRoot.innerHTML = '' +
              '<div class="grid gap-2 text-sm">' +
              '<div class="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-3 text-dpp-muted">' +
              '<span>' + escapeHtml(subtotalLabel || compareLabel) + '</span>' +
              '<span>' + escapeHtml(formatMoney(compareAtCents > priceCents ? compareAtCents : priceCents, window.Shopify && window.Shopify.money_format)) + '</span>' +
              '</div>' +
              (bundleDiscount > 0
                ? '<div class="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-3 font-semibold text-dpp-focus"><span>' + escapeHtml(discountRowLabel) + '</span><span>-' + escapeHtml(formatMoney(bundleDiscount, window.Shopify && window.Shopify.money_format)) + '</span></div>'
                : '') +
              (volumeSavings > 0
                ? '<div class="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-3 font-semibold text-dpp-focus"><span>' + escapeHtml(volumeSavingsLabel) + '</span><span>-' + escapeHtml(formatMoney(volumeSavings, window.Shopify && window.Shopify.money_format)) + '</span></div>'
                : '') +
              '<div class="mt-1 border-t border-dpp-border pt-3">' +
              '<div class="grid grid-cols-[minmax(0,1fr)_auto] items-end gap-3">' +
              '<span class="text-base font-extrabold leading-tight text-dpp-text">' + escapeHtml(totalLabel || priceLabel) + '</span>' +
              '<span class="text-2xl font-extrabold leading-none text-dpp-price">' + escapeHtml(formatMoney(priceCents, window.Shopify && window.Shopify.money_format)) + '</span>' +
              '</div>' +
              (savingsCents > 0
                ? '<div class="mt-3 grid grid-cols-[minmax(0,1fr)_auto] items-center gap-3 rounded-dppsm border border-dpp-orange/30 bg-dpp-orangeSoft px-3 py-2 font-extrabold text-dpp-orange"><span>' + escapeHtml(totalSavingsLabel || savingsLabel) + '</span><span>' + escapeHtml(formatMoney(savingsCents, window.Shopify && window.Shopify.money_format)) + '</span></div>'
                : '') +
              '</div>' +
              '</div>'
            priceRoot.classList.remove('hidden')
          } else {
            priceRoot.innerHTML = ''
            priceRoot.classList.add('hidden')
          }
        }
      }
      function getSourcePopupItem() {
        var sourceButton = sourceButtons.find(function (button) {
          return String(button.getAttribute('data-source-variant-id') || '') === getSourceVariantId()
        })
        var sourceOption = getSourceOption()
        var sourceTitle = sourceOption ? (sourceOption.getAttribute('data-title') || sourceOption.textContent || '').trim() : ''
        var baseTitle = summaryTitle ? (summaryTitle.getAttribute('data-base-title') || '') : ''
        var image = sourceButton ? sourceButton.getAttribute('data-source-image-url') || '' : ''
        var imageAlt = sourceButton ? sourceButton.getAttribute('data-source-image-alt') || '' : ''

        if (!baseTitle && summaryTitle) {
          baseTitle = (summaryTitle.getAttribute('data-base-title') || summaryTitle.textContent || '').split(' - ')[0].trim()
        }

        return {
          title: buildVariantDisplayTitle(baseTitle, sourceTitle, getSourceVariantId(), ''),
          imageUrl: image,
          imageAlt: imageAlt || baseTitle,
          quantity: 1,
          priceCents: normalizeToCents(sourceOption ? sourceOption.getAttribute('data-price') : 0),
          statusLabel: popupCurrentLabel
        }
      }

      function renderPopupItem(item) {
        var title = item && item.title ? item.title : ''
        var quantityLabel = replaceTokens(quantityTemplate, { QUANTITY: String((item && item.quantity) || 1) })
        return '' +
          '<div class="grid grid-cols-[56px_minmax(0,1fr)] gap-2 rounded-dppmd bg-dpp-surfaceSoft/70 p-2 md:grid-cols-[64px_minmax(0,1fr)_auto] md:gap-3 md:p-3">' +
          '<span class="overflow-hidden rounded-dppsm bg-white">' +
          (item && item.imageUrl
            ? '<img class="h-14 w-14 object-contain bg-white p-1 md:h-16 md:w-16 md:p-1.5" src="' + escapeHtml(item.imageUrl) + '" alt="' + escapeHtml(item.imageAlt || title) + '" loading="lazy">'
            : '<span class="block h-14 w-14 bg-white md:h-16 md:w-16"></span>') +
          '</span>' +
          '<span class="grid min-w-0 content-center gap-1">' +
          '<span class="text-sm font-extrabold leading-snug text-dpp-text">' + escapeHtml(quantityLabel) + ' - ' + escapeHtml(title) + '</span>' +
          '</span>' +
          renderBundleLinePrice(item, false) +
          '</div>'
      }

      function renderBundleLinePrice(item, showBundleDiscount) {
        var quantity = (item && item.quantity) || 1
        var unitPrice = item && item.priceCents ? normalizeToCents(item.priceCents) : 0
        var compareAtPrice = item && item.compareAtPriceCents ? normalizeToCents(item.compareAtPriceCents) : 0
        var originalLinePrice = Math.max(compareAtPrice, unitPrice) * quantity

        if (originalLinePrice <= 0) return ''

        var discountedLinePrice = unitPrice * quantity
        if (showBundleDiscount !== false && discountRate > 0 && discountRate < 100) {
          discountedLinePrice = Math.round(originalLinePrice * (1 - (discountRate / 100)))
        }

        return '' +
          '<span class="flex flex-wrap items-baseline gap-x-2 gap-y-1 text-sm md:justify-end">' +
          (discountedLinePrice < originalLinePrice
            ? '<span class="font-semibold text-dpp-muted line-through">' + escapeHtml(formatMoney(originalLinePrice, window.Shopify && window.Shopify.money_format)) + '</span>'
            : '') +
          '<span class="font-extrabold text-dpp-price">' + escapeHtml(formatMoney(discountedLinePrice, window.Shopify && window.Shopify.money_format)) + '</span>' +
          '</span>'
      }

      function renderBundleBlockRow(item) {
        var title = item && item.title ? item.title : ''
        var quantityLabel = replaceTokens(quantityTemplate, { QUANTITY: String((item && item.quantity) || 1) })
        var statusLabel = item && item.statusLabel ? item.statusLabel : ''
        return '' +
          '<div class="grid grid-cols-[52px_minmax(0,1fr)] gap-2 p-1 md:grid-cols-[56px_minmax(0,1fr)_auto] md:items-center">' +
          '<span class="overflow-hidden rounded-dppsm bg-white">' +
          (item && item.imageUrl
            ? '<img class="h-14 w-14 object-contain bg-white p-1" src="' + escapeHtml(item.imageUrl) + '" alt="' + escapeHtml(item.imageAlt || title) + '" loading="lazy">'
            : '<span class="block h-14 w-14 bg-white"></span>') +
          '</span>' +
          '<span class="grid min-w-0 content-center gap-1">' +
          (statusLabel ? '<span class="w-fit rounded-full bg-white px-2 py-1 text-[11px] font-extrabold uppercase tracking-[0.12em] text-dpp-focus">' + escapeHtml(statusLabel) + '</span>' : '') +
          '<span class="text-sm font-extrabold leading-snug text-dpp-text">' + escapeHtml(quantityLabel) + ' - ' + escapeHtml(title) + '</span>' +
          '</span>' +
          renderBundleLinePrice(item) +
          '</div>'
      }

      function renderPopupBundleBlock(sourceItem, addedItems) {
        return '' +
          '<div class="grid divide-y divide-dpp-teal/30 rounded-dppmd border border-dpp-teal/30 bg-white p-2 shadow-card md:p-3">' +
          renderBundleBlockRow(sourceItem) +
          (addedItems.length > 0
            ? addedItems.map(renderBundleBlockRow).join('')
            : '') +
          '</div>'
      }

      function renderPopupPrice(bundleVariant) {
        if (!popupPrice) return
        var priceCents = bundleVariant ? normalizeToCents(bundleVariant.bundlePriceCents) : 0
        var compareAtCents = bundleVariant ? normalizeToCents(bundleVariant.bundleCompareAtPriceCents) : 0
        if (priceCents > 0 && compareAtCents <= priceCents && discountRate > 0 && discountRate < 100) {
          compareAtCents = Math.round(priceCents / (1 - (discountRate / 100)))
        }
        var savingsCents = compareAtCents > priceCents ? compareAtCents - priceCents : 0
        syncPopupSavingsBadge(savingsCents)
        popupPrice.innerHTML = priceCents > 0
          ? '<div class="grid gap-2 rounded-dppmd border border-dpp-border bg-dpp-surfaceSoft/80 p-3 text-sm">' +
            '<div class="flex flex-wrap items-end justify-between gap-2">' +
            '<span class="text-base font-extrabold text-dpp-text">' + escapeHtml(popupBundlePriceLabel || totalLabel || priceLabel) + '</span>' +
            '<span class="flex flex-wrap items-baseline justify-end gap-2">' +
            (savingsCents > 0 ? '<span class="text-sm font-semibold text-dpp-muted line-through">' + escapeHtml(formatMoney(compareAtCents > priceCents ? compareAtCents : priceCents, window.Shopify && window.Shopify.money_format)) + '</span>' : '') +
            '<span class="text-2xl font-extrabold leading-none text-dpp-price">' + escapeHtml(formatMoney(priceCents, window.Shopify && window.Shopify.money_format)) + '</span>' +
            '</span>' +
            '</div>' +
            '</div>'
          : ''
        popupPrice.classList.toggle('hidden', !popupPrice.innerHTML)
      }

      function setPopupFeedback(message) {
        if (!popupFeedback) return
        popupFeedback.textContent = message || ''
        popupFeedback.classList.toggle('hidden', !message)
      }

      function openBundlePopup(sourceLineKey) {
        if (!popup || !currentEntry) return false
        var bundleVariant = getResolvedBundle(currentEntry)
        var components = bundleVariant && Array.isArray(bundleVariant.bundleComponents) ? bundleVariant.bundleComponents : []
        var sourceItem = getSourcePopupItem()
        var bundleItems = components.length > 0
          ? components.map(function (component) {
              return {
                title: buildVariantDisplayTitle(component.productTitle, component.variantTitle, component.variantGid, component.firstVariantGid),
                imageUrl: component.imageUrl || '',
                imageAlt: component.imageAlt || component.productTitle || '',
                quantity: component.quantity || 1,
                priceCents: component.priceCents || 0,
                compareAtPriceCents: component.compareAtPriceCents || 0
              }
            })
          : [{
              title: buildBundleDisplayTitle(bundleVariant),
              imageUrl: bundleVariant.bundleImageUrl || '',
              imageAlt: bundleVariant.bundleImageAlt || buildBundleDisplayTitle(bundleVariant),
              quantity: 1
            }]

        pendingSourceLineKey = sourceLineKey || ''
        if (popupSource) popupSource.innerHTML = renderPopupItem(sourceItem)
        if (popupItems) popupItems.innerHTML = renderPopupBundleBlock(sourceItem, bundleItems)
        if (popupCopy && popup.getAttribute('data-bundle-popup-text')) popupCopy.textContent = popup.getAttribute('data-bundle-popup-text')
        renderPopupPrice(bundleVariant)
        setPopupFeedback('')
        popupPreviouslyFocused = document.activeElement
        popup.classList.remove('hidden')
        popup.classList.add('flex')
        popup.setAttribute('aria-hidden', 'false')
        if (setBodyScrollLock) setBodyScrollLock('bundle-popup', true)
        window.setTimeout(function () {
          var focusTarget = popup.querySelector('[data-bundle-popup-keep], [data-bundle-popup-submit], [data-bundle-popup-close]')
          if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus()
        }, 0)
        return true
      }

      root.DPPBundleConfigurator = Object.assign(root.DPPBundleConfigurator || {}, {
        openBundlePopup: openBundlePopup
      })

      function closeBundlePopup() {
        if (!popup) return
        popup.classList.add('hidden')
        popup.classList.remove('flex')
        popup.setAttribute('aria-hidden', 'true')
        if (setBodyScrollLock) setBodyScrollLock('bundle-popup', false)
        if (popupPreviouslyFocused && typeof popupPreviouslyFocused.focus === 'function') popupPreviouslyFocused.focus()
      }

      function showRegularProductCartResult() {
        closeBundlePopup()
        window.setTimeout(function () {
          window.location.href = getCartUrl ? getCartUrl() : '/cart'
        }, 0)
      }

      function getCartAddLineKey(payload) {
        if (!payload) return ''
        if (payload.key) return payload.key
        if (Array.isArray(payload.items) && payload.items[0] && payload.items[0].key) return payload.items[0].key
        return ''
      }

      function addRegularProductForPopup(purchaseForm, submitButton) {
        if (!purchaseForm || !currentEntry) return false
        if (submitButton) submitButton.disabled = true
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(purchaseForm)
        })
          .then(function (response) {
            if (!response.ok) throw new Error('add_failed')
            return response.json()
          })
          .then(function (payload) {
            var refreshCart = window.DPPThemeCart && window.DPPThemeCart.refresh
            var openPopup = function () {
              openBundlePopup(getCartAddLineKey(payload))
            }

            return refreshCart ? refreshCart('bundle-popup-product-add').then(openPopup).catch(openPopup) : openPopup()
          })
          .catch(function () {
            window.location.href = getCartUrl ? getCartUrl() : '/cart'
          })
          .finally(function () {
            if (submitButton) submitButton.disabled = false
          })
        return true
      }

      function syncFromSourceVariant() {
        var sourceOption = getSourceOption()
        if (!sourceOption) return
        setPriceDisplay(sourceOption.getAttribute('data-price') || '0', sourceOption.getAttribute('data-compare-price') || '0')
        setAvailabilityState(sourceOption.getAttribute('data-available') === 'true')
        syncTitleBadgeFromSource()
      }
      function entryHasConfiguredStepVariants(entry) {
        return stepConfigs.every(function (step) {
          var value = getBundleStepValue(entry, step.type)
          return !value || getEntryVariantIds(entry, step.variantIdKey, step.variantIdsKey).length > 0
        })
      }
      function getApplicableEntries() {
        var sourceVariantId = getSourceVariantId()
        var specificEntries = sourceVariantId
          ? entries.filter(function (entry) { return String(entry.sourceVariantId || '') === sourceVariantId })
          : []
        var genericEntries = entries.filter(function (entry) { return !entry.sourceVariantId })
        var preferredEntries = specificEntries.length > 0 ? specificEntries.concat(genericEntries) : genericEntries
        var seenKeys = {}
        return preferredEntries.filter(function (entry) {
          if (!entryHasConfiguredStepVariants(entry)) return false
          var key = stepConfigs.map(function (step) {
            return getBundleStepValue(entry, step.type)
          }).join('||').toLowerCase()
          if (seenKeys[key]) return false
          seenKeys[key] = true
          return true
        })
      }
      function uniqueOptionValues(optionEntries, fieldName) {
        return optionEntries.reduce(function (values, entry) {
          var value = (entry[fieldName] || '').trim()
          if (!value || values.indexOf(value) !== -1) return values
          values.push(value)
          return values
        }, [])
      }
      function getOptionDisplayLabel(value, type, optionEntries) {
        var displayKey = type + 'DisplayValue'
        var valueKey = type + 'Value'
        var matchingEntry = (optionEntries || []).find(function (entry) {
          return entry && String(entry[valueKey] || '').trim() === value && String(entry[displayKey] || '').trim()
        })
        return matchingEntry ? String(matchingEntry[displayKey] || '').trim() : getBundleOptionLabel(value)
      }
      function renderOptionSelect(container, values, selectedValue, type, optionEntries) {
        if (!container) return ''
        var nextValue = values.indexOf(selectedValue) !== -1 ? selectedValue : (values[0] || '')
        var label = container.getAttribute('data-bundle-step-select-label') || ''
        var labelId = 'BundleStep-' + type + '-' + Math.random().toString(36).slice(2)
        var optionsMarkup = values.map(function (value) {
          return '<option value="' + escapeHtml(value) + '"' + (value === nextValue ? ' selected' : '') + '>' + escapeHtml(getOptionDisplayLabel(value, type, optionEntries)) + '</option>'
        }).join('')
        container.innerHTML = '' +
          (label ? '<label class="sr-only" id="' + escapeHtml(labelId) + '">' + escapeHtml(label) + '</label>' : '') +
          '<select class="min-h-11 w-full rounded-dppsm border border-dpp-border bg-dpp-surfaceSoft px-3 py-2 text-sm font-semibold text-dpp-text" data-bundle-configurator-select data-option-type="' + escapeHtml(type) + '"' + (label ? ' aria-labelledby="' + escapeHtml(labelId) + '"' : '') + '>' +
          optionsMarkup +
          '</select>'
        return nextValue
      }
      function getResolvedBundle(entry) {
        if (!entry) return null
        var resolved = bundleDetailsByGid[entry.bundleVariantGid] || {}
        return {
          sourceVariantId: entry.sourceVariantId || '',
          primaryValue: entry.primaryValue || '',
          secondaryValue: entry.secondaryValue || '',
          tertiaryValue: entry.tertiaryValue || '',
          quaternaryValue: entry.quaternaryValue || '',
          summary: entry.summary || '',
          bundleVariantId: entry.bundleVariantId,
          bundleVariantGid: entry.bundleVariantGid,
          bundleVariantTitle: resolved.bundleVariantTitle || entry.bundleVariantTitle || '',
          bundleAvailable: Object.prototype.hasOwnProperty.call(resolved, 'bundleAvailable') ? resolved.bundleAvailable : !!entry.bundleAvailable,
          bundlePriceCents: Object.prototype.hasOwnProperty.call(resolved, 'bundlePriceCents') ? resolved.bundlePriceCents : normalizeToCents(entry.bundlePriceCents),
          bundleCompareAtPriceCents: Object.prototype.hasOwnProperty.call(resolved, 'bundleCompareAtPriceCents') ? resolved.bundleCompareAtPriceCents : normalizeToCents(entry.bundleCompareAtPriceCents),
          bundleProductTitle: resolved.bundleProductTitle || entry.bundleProductTitle || '',
          bundleProductUrl: resolved.bundleProductUrl || entry.bundleProductUrl || '',
          bundleImageUrl: resolved.bundleImageUrl || entry.bundleImageUrl || '',
          bundleImageAlt: resolved.bundleImageAlt || entry.bundleImageAlt || '',
          bundleComponents: resolved.bundleComponents || []
        }
      }
      function applySelectedEntry(entry) {
        currentEntry = entry || null
        if (!entry) {
          syncFromSourceVariant()
          renderSummary(null, noMatchLabel)
          setFeedback(noMatchLabel)
          return
        }
        var bundleVariant = getResolvedBundle(entry)
        syncFromSourceVariant()
        syncTitleBadgeFromSource()
        renderSummary(bundleVariant, discountLabel || mappingNote)
        setFeedback('')
      }
      function buildBundleLineProperties(role, groupId, requiredQuantity, bundleStep, bundleStepCount, extraProperties) {
        var properties = {
          _bundle_configurator_id: String(configuratorId || ''),
          _bundle_base_product_id: String(baseProductId || ''),
          _bundle_discount_percentage: String(discountRate || 0),
          _bundle_group_id: groupId,
          _bundle_step: String(bundleStep || role),
          _bundle_step_count: String(bundleStepCount || 1),
          _dpp_bundle_group: groupId,
          _dpp_bundle_source: 'variant_configurator',
          _dpp_bundle_discount: String(discountRate || 0),
          _dpp_bundle_role: role,
          _dpp_bundle_required_quantity: String(requiredQuantity || 1)
        }
        Object.keys(extraProperties || {}).forEach(function (key) {
          if (extraProperties[key]) properties[key] = extraProperties[key]
        })
        return properties
      }
      function getEntryVariantIds(entry, singleKey, listKey) {
        var ids = []
        var seen = {}
        var rawIds = Array.isArray(entry[listKey]) ? entry[listKey] : []
        if (entry[singleKey]) rawIds = rawIds.concat([entry[singleKey]])
        rawIds.forEach(function (variantId) {
          var id = variantId ? String(variantId) : ''
          if (!id || seen[id]) return
          seen[id] = true
          ids.push(id)
        })
        return ids
      }
      function parseQuantityValue(value) {
        var quantity = parseInt(value, 10)
        return quantity > 0 ? quantity : 1
      }
      function getEntryVariantQuantities(entry, singleKey, listKey) {
        var value = entry[listKey]
        var quantities = []
        if (Array.isArray(value)) {
          quantities = value
        } else if (typeof value === 'string' && value.trim()) {
          quantities = value.split(',')
        }
        if (entry[singleKey]) quantities = quantities.concat([entry[singleKey]])
        return quantities.map(parseQuantityValue)
      }
      function getEntryVariantComponents(entry, singleVariantKey, listVariantKey, singleQuantityKey, listQuantityKey) {
        var ids = getEntryVariantIds(entry, singleVariantKey, listVariantKey)
        var quantities = getEntryVariantQuantities(entry, singleQuantityKey, listQuantityKey)
        return ids.map(function (id, index) {
          return {
            id: id,
            quantity: quantities[index] || 1
          }
        })
      }
      function appendBundleStepItems(items, components, role, bundleStep, bundleStepCount, label, sourceVariantId, groupId, bundleQuantity) {
        var quantityMultiplier = Math.max(parseInt(bundleQuantity || '1', 10) || 1, 1)
        var existingItems = {}
        items.forEach(function (item) {
          var itemGroup = item.properties && item.properties._dpp_bundle_group ? item.properties._dpp_bundle_group : ''
          var itemRole = item.properties && item.properties._dpp_bundle_role ? item.properties._dpp_bundle_role : ''
          existingItems[String(item.id) + '::' + itemGroup + '::' + itemRole] = item
        })
        components.forEach(function (component) {
          var variantId = component.id
          if (!variantId || variantId === sourceVariantId) return
          var itemKey = String(variantId) + '::' + groupId + '::' + role
          if (existingItems[itemKey]) {
            var requiredQuantity = parseQuantityValue(existingItems[itemKey].properties._dpp_bundle_required_quantity || '0') + component.quantity
            existingItems[itemKey].quantity += component.quantity * quantityMultiplier
            existingItems[itemKey].properties._dpp_bundle_required_quantity = String(requiredQuantity)
            return
          }
          var item = {
            id: Number(variantId),
            quantity: component.quantity * quantityMultiplier,
            properties: buildBundleLineProperties(role, groupId, component.quantity, bundleStep, bundleStepCount, {
              _dpp_bundle_parent_variant_id: sourceVariantId,
              _dpp_bundle_step_label: label
            })
          }
          items.push(item)
          existingItems[itemKey] = item
        })
      }
      function addConfiguredBundle(purchaseForm, submitButton, sourceLineKey) {
        if (!purchaseForm || !currentEntry) return false
        var idInput = purchaseForm.querySelector('[name="id"]')
        var quantityInput = purchaseForm.querySelector('[name="quantity"]')
        var sourceVariantId = sourceSelect ? sourceSelect.value : (idInput ? idInput.value : '')
        var quantity = Math.max(parseInt(quantityInput && quantityInput.value ? quantityInput.value : '1', 10) || 1, 1)
        var selectedSteps = stepConfigs.map(function (step) {
          return {
            config: step,
            value: getBundleOptionLabel(currentEntry[step.valueKey] || ''),
            variantIds: getEntryVariantIds(currentEntry, step.variantIdKey, step.variantIdsKey),
            components: getEntryVariantComponents(currentEntry, step.variantIdKey, step.variantIdsKey, step.quantityKey, step.quantitiesKey)
          }
        })
        var groupId = 'dpp-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8)
        if (!sourceVariantId) {
          setFeedback(noMatchLabel || mappingNote)
          return true
        }
        if (selectedSteps.some(function (step) { return step.value && step.variantIds.length === 0 })) {
          setFeedback(noMatchLabel || mappingNote)
          return true
        }
        var configuredSteps = selectedSteps.filter(function (step) {
          return step.value && step.components.length > 0
        })
        var selectedStepCount = configuredSteps.length
        var items = []
        var baseExtraProperties = {}
        selectedSteps.forEach(function (step, index) {
          var stepNumber = index + 1
          baseExtraProperties[step.config.label] = step.value
          baseExtraProperties['_dpp_bundle_step_' + stepNumber + '_variant_id'] = step.variantIds.join(',')
        })
        var baseProperties = buildBundleLineProperties('base', groupId, 1, 'base', selectedStepCount, baseExtraProperties)
        items.push({
          id: Number(sourceVariantId),
          quantity: quantity,
          properties: baseProperties
        })
        configuredSteps.forEach(function (step, index) {
          appendBundleStepItems(items, step.components, step.config.role, String(index + 1), selectedStepCount, step.value, sourceVariantId, groupId, quantity)
        })
        if (submitButton) submitButton.disabled = true
        setFeedback('')
        var removeSourceLine = sourceLineKey
          ? fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ id: sourceLineKey, quantity: 0 })
            }).then(function (response) {
              if (!response.ok) throw new Error('bundle_source_remove_failed')
              return response.json()
            })
          : Promise.resolve()

        removeSourceLine.then(function () {
          return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: items })
          })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('bundle_add_failed')
            return response.json()
          })
          .then(function () {
            window.location.href = getCartUrl ? getCartUrl() : '/cart'
          })
          .catch(function () {
            setFeedback(noMatchLabel || mappingNote)
            setPopupFeedback(popup ? (popup.getAttribute('data-bundle-popup-error-label') || noMatchLabel || mappingNote) : '')
            if (submitButton) submitButton.disabled = false
          })
        return true
      }
      function renderConfigurator() {
        var applicableEntries = getApplicableEntries()
        var primaryValues = uniqueOptionValues(applicableEntries, stepConfigs[0].valueKey)
        if (primaryValues.length === 0) {
          root.classList.add('hidden')
          stepConfigs.forEach(function (step, index) {
            if (step.optionsRoot) step.optionsRoot.innerHTML = ''
            if (index > 0 && step.stepRoot) step.stepRoot.classList.add('hidden')
          })
          applySelectedEntry(null)
          return
        }
        root.classList.remove('hidden')
        var candidateEntries = applicableEntries
        stepConfigs.forEach(function (step, index) {
          var optionEntries = index === 0
            ? applicableEntries
            : candidateEntries.filter(function (entry) {
                return !!getBundleStepValue(entry, step.type)
              })
          var values = index === 0
            ? primaryValues
            : uniqueOptionValues(optionEntries, step.valueKey)
          if (step.stepRoot) step.stepRoot.classList.toggle('hidden', values.length === 0)
          if (values.length > 0) {
            selectionState[step.type] = renderOptionSelect(step.optionsRoot, values, selectionState[step.type], step.type, optionEntries)
            candidateEntries = candidateEntries.filter(function (entry) {
              return getBundleStepValue(entry, step.type) === selectionState[step.type]
            })
          } else {
            selectionState[step.type] = ''
            if (step.optionsRoot) step.optionsRoot.innerHTML = ''
          }
        })
        var selectedEntry = applicableEntries.find(function (entry) {
          return stepConfigs.every(function (step) {
            var value = getBundleStepValue(entry, step.type)
            return !selectionState[step.type] || value === selectionState[step.type]
          })
        }) || applicableEntries[0]
        applySelectedEntry(selectedEntry)
      }
      if (sourceSelect) {
        sourceSelect.addEventListener('change', function () {
          syncTitleBadgeFromSource()
          renderConfigurator()
        })
      }
      var purchaseForm = sourceSelect ? sourceSelect.closest('form') : section.querySelector('form[action*="/cart/add"]')
      root.addEventListener('click', function (event) {
        var bundleSubmitButton = event.target.closest('[data-bundle-submit]')
        if (bundleSubmitButton) {
          event.preventDefault()
          addConfiguredBundle(purchaseForm, bundleSubmitButton)
          return
        }
        var sourceButton = event.target.closest('[data-bundle-source-option]')
        if (sourceButton && sourceSelect) {
          var sourceVariantId = sourceButton.getAttribute('data-source-variant-id') || ''
          if (sourceVariantId && String(sourceSelect.value) !== sourceVariantId) {
            sourceSelect.value = sourceVariantId
            sourceSelect.dispatchEvent(new Event('change', { bubbles: true }))
          }
          return
        }
      })
      root.addEventListener('change', function (event) {
        var optionSelect = event.target.closest('[data-bundle-configurator-select]')
        if (!optionSelect) return
        var optionType = optionSelect.getAttribute('data-option-type') || ''
        var optionValue = optionSelect.value || ''
        if (optionType === 'primary') {
          selectionState.primary = optionValue
          selectionState.secondary = ''
          selectionState.tertiary = ''
          selectionState.quaternary = ''
          renderConfigurator()
        } else if (optionType === 'secondary') {
          selectionState.secondary = optionValue
          selectionState.tertiary = ''
          selectionState.quaternary = ''
          renderConfigurator()
        } else if (optionType === 'tertiary') {
          selectionState.tertiary = optionValue
          selectionState.quaternary = ''
          renderConfigurator()
        } else if (optionType === 'quaternary') {
          selectionState.quaternary = optionValue
          renderConfigurator()
        }
      })
      if (purchaseForm) {
        purchaseForm.addEventListener('submit', function (event) {
          var submitter = event.submitter || document.activeElement
          if (submitter && submitter.closest && submitter.closest('[data-bundle-submit]')) return
          if (!currentEntry) return
          event.preventDefault()
          event.stopPropagation()
          addRegularProductForPopup(purchaseForm, submitter && submitter.matches && submitter.matches('button[type="submit"]') ? submitter : purchaseForm.querySelector('button[type="submit"]'))
        }, true)
      }
      if (popup) {
        popup.addEventListener('click', function (event) {
          if (event.target.closest('[data-bundle-popup-keep]')) {
            event.preventDefault()
            showRegularProductCartResult()
            return
          }
          if (event.target.closest('[data-bundle-popup-close], [data-bundle-popup-dismiss]')) {
            event.preventDefault()
            closeBundlePopup()
            return
          }
          if (event.target.closest('[data-bundle-popup-configure]')) {
            event.preventDefault()
            closeBundlePopup()
            var openButton = root.querySelector('[data-bundle-configurator-open]')
            if (openButton) openButton.click()
            root.scrollIntoView({ behavior: 'smooth', block: 'start' })
            return
          }
          var submitButton = event.target.closest('[data-bundle-popup-submit]')
          if (submitButton) {
            event.preventDefault()
            setPopupFeedback('')
            addConfiguredBundle(purchaseForm, submitButton, pendingSourceLineKey)
          }
        })
        document.addEventListener('keydown', function (event) {
          if (popup.getAttribute('aria-hidden') !== 'false') return
          if (event.key === 'Escape') {
            closeBundlePopup()
            return
          }
          if (trapFocusWithin) trapFocusWithin(event, popup)
        })
      }
      syncTitleBadgeFromSource()
      renderConfigurator()
      fetchBundleVariantDetails(entries.map(function (entry) {
        return entry.bundleVariantGid
      }))
        .then(function (detailsByGid) {
          bundleDetailsByGid = detailsByGid || {}
          renderConfigurator()
        })
        .catch(function () {})
    })
  }
  window.DPPThemeProductBundles = Object.assign(window.DPPThemeProductBundles || {}, {
    setupBundleConfigurator: setupBundleConfigurator
  })

  function initializeProductBundles() {
    setupBundleConfigurator()
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProductBundles)
  } else {
    initializeProductBundles()
  }
})()
